module.exports = "/deep/ .form-control.expy { width:20px;}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/ippayment/ippayment.component.css
// module id = ./src/app/shared/components/ippayment/ippayment.component.css
// module chunks = main